export const colors = { primary: 'bg-[#4f87e8]' };

export const snackBarColors = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
};
